// CertBuddy's own staff. The suppliers and external reviewers CertBuddy invites are created
// with its org_id (o1), so the role is checked too; the backend's is_certbuddy_member matches.
const EXTERNAL_ROLES = new Set(["cbSupplier", "cbAuthority"]);

export const isExternalRole = (role) => EXTERNAL_ROLES.has(role);

export const isCertBuddyMember = (user) =>
  Boolean(user) && user.org_id === "o1" && !isExternalRole(user.role);

// The CertBuddyAI org's own staff, for screens that decide by the current organization.
// Fails closed while the user has not loaded: no user, no staff screens.
export const isCertBuddyOrgStaff = (org, user) =>
  Boolean(org) &&
  Boolean(user) &&
  (org.org_id === "o1" || org.org_name === "CertBuddyAI") &&
  !isExternalRole(user.role);

// Training's is_platform_admin: may upload into another org or a domain.
export const isPlatformAdmin = (user) =>
  Boolean(user) && user.org_id === "o1" && user.role === "cbProgram";
